export default {
  name: "res-divider",
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};